import {
  GetUserProfilesDocument,
  SetProfilesDocument,
} from './generated/graphql'
import { createMutationHelper, createQueryHook, modifyQueryHook } from './utils'

export const useGetUserProfiles = modifyQueryHook(
  createQueryHook(GetUserProfilesDocument),
  {
    transform: (userId: string) => ({
      userId,
    }),
    reduce: r => r?.user,
  },
)
export const [useSetProfiles, executeSetProfiles] =
  createMutationHelper(SetProfilesDocument)

